import {dcpcApi} from "../../Services/api/dcpcApi";
import axios from "axios";
import {hostWithPrefix} from "../Constructor/common/ApiCommon";

const PRIVILEGES_TAG = 'Privileges'

dcpcApi.enhanceEndpoints({addTagTypes: [PRIVILEGES_TAG]});

const privilegesApi = dcpcApi.injectEndpoints({
    endpoints: (builder) => ({
        getPrivileges: builder.query({
            query: () => ({
                url: 'auth/privileges',
                method: 'get'
            }),
            providesTags: [PRIVILEGES_TAG]
        })
    })
})

export const {
    useGetPrivilegesQuery
} = privilegesApi;


export function getAllRolesForPrivilege(privilegeId) {
    return axios({
        url: 'http://' + hostWithPrefix + '/auth/privileges/' + privilegeId + "/roles",
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    })
}

export function deletePrivilegeForRole(privilegeId, roleName) {
    return axios({
        url: 'http://' + hostWithPrefix + '/auth/privileges/' + privilegeId + "/roles/" + roleName,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        }
    })
}

export function getAllRoles() {
    return axios({
        url: 'http://' + hostWithPrefix + '/auth/keycloak/roles',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    })
}

export function saveRolesForPrivilege(privilegeId, roles) {
    return axios({
        url: 'http://' + hostWithPrefix + '/auth/privilege/' + privilegeId + '/roles',
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(roles)
    })
}